import { obtenerSesionAbiertaPorPuntoYFecha } from "../infraestructure/supabase/cajaSesion.repository.js";
import { mapCajaSesionFromDB } from "../domain/mappers/cajaSesion.mapper.js";

export async function obtenerSesionAbiertaPorDiaUseCase({ punto, fecha }) {
  const sesionDB = await obtenerSesionAbiertaPorPuntoYFecha(punto, fecha);
  if (!sesionDB) return null; // no hay sesión para la fecha
  return mapCajaSesionFromDB(sesionDB); // sesión existente
}